import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ListData from './ListData';
import WizardFormFirstPage from '../common/WizardFormFirstPage';
import WizardFormSecondPage from '../common/WizardFormSecondPage';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../../components';

import { createEmailManager, getEmailManagerDetail, editEmailManager, emailTemplate } from '../../../../redux/actions/emailManagerActions';
import {renderAlert,clearAlert} from '../../../../redux/actions/alertsActions';

import moment from 'moment';
import { getCities } from "../../../../redux/actions/countryCityActions";
let campaignID;
let isLoading=false;
class MultiOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: ['Home', 'Email Manager', 'Multi Offer Email'],
      links: ["home",'email-manager/overview','email-manager/multiofferemail'],
      page: 1,
      fetchData: '',
      campaignName: '',
      subject: '',
      customEmailContent: '',
      show: false,
      alertMessage:'',
      title: 'Multi Offer Email',
      campDate: '',
      listData: [],
      dealID: [],
      multi_lang: "no",
      citiesList: [],
    }

    this.nextPage = this.nextPage.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.setData = this.setData.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePageChange = () =>{
    
    campaignID = this.props.match.params.campaignID ? this.props.match.params.campaignID : '';
    if (campaignID !== '')
    {
      // isLoading="true";
      this.props.getEmailManagerDetail(campaignID); 
    }else{
      if(sessionStorage.getItem('campData')){
        this.setState({campDate: sessionStorage.getItem('campData'), scheduleDateTime: new Date(sessionStorage.getItem('campData')), scheduleStatus: true});
      }
    }

    this.props.emailTemplate({templateName: 'emailManagerMultiDeal'});
  }

  componentWillMount(){
    this.props.clearAlert ();
    this.handleDismiss();
    this.handlePageChange();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){ 
      this.setState({
        enable_secondstreet: siteData.enable_secondstreet,
        multi_lang: siteData.multi_lang,
      }); 
    }
    this.props.getCities();
  }

  componentWillReceiveProps(nextProps){
    if (this.props.activecities !== nextProps.activecities && nextProps.activecities) {
      this.setState({ citiesList: nextProps.activecities });
    }

    if(this.props.template != nextProps.template){
      if(nextProps.template){
        this.setState({
          customEmailContent: nextProps.template.data.content,
          french_customEmailContent: nextProps.template.data.french_content,
        });
      }
    }
    if(this.props.emailData != nextProps.emailData){
      if(nextProps.emailData){
        let data = nextProps.emailData.data;
        this.setState({
          campaignName: data.campaignName,
          subject: data.subject,
          french_subject: data.french_subject,
          french_customEmailContent: data.french_customEmailContent,
          customEmailContent: data.customEmailContent,
          dealID: data.dealID.split(","),
          listData: JSON.parse(data.listData),
          scheduleDateTime: new Date(data.scheduleOn),
          scheduleStatus: true,
          campaignCityID: data.campCityID,
        });
      }
      isLoading = false;
    }
    if(this.props.emailUpdateStatus !== nextProps.emailUpdateStatus){
      if(nextProps.emailUpdateStatus){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('success', nextProps.emailUpdateStatus.message);
        this.setState({page: 1});
        window.scrollTo(0, 0);
      }
      isLoading = false;
    }
    if(this.props.emailStatus !== nextProps.emailStatus){
        if(nextProps.emailStatus){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('success', nextProps.emailStatus.message);
          this.setState({page: 1})
          this.state.emailType = '';
          this.state.campaignName = '';
          this.state.subject = '';
          this.state.customEmailContent = '';
          this.state.french_subject = '';
          this.state.french_customEmailContent = '';
          this.state.scheduleOn = '';
          this.state.cities = '';
          this.state.subscriberType = '';
          this.state.subscriberStartDate = '';
          this.state.subscriberEndDate = '';
          this.state.filterPurchase = '';
          this.state.catID = '';
          this.state.listData = '';
          this.state.dealID = '';
          this.state.cityID = '';
          window.scrollTo(0, 0);
          this.handlePageChange();
        }
    }

    if(this.props.error !== nextProps.error){
      if(nextProps.error){ 
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('warning',nextProps.error);
        window.scrollTo(0, 0); 
      }
      isLoading = false;
    } 
    if(nextProps.message){
      this.handleShow();
      this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      window.scrollTo(0, 0);
      isLoading = false;
    }

  }
  nextPage() {
    this.setState({ page: this.state.page + 1 })
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 })
  }

  setData = (data) => { 
    this.setState(data);
  }

  saveData = (data) => {
    this.setState(data); 
    isLoading = true;
    if(campaignID == ''){
      const saveData = {
        emailType: 'multiOffer',
        campaignName: this.state.campaignName,
        subject: this.state.subject,
        customEmailContent: this.state.customEmailContent,
        french_subject: (this.state.french_subject) ? this.state.french_subject : '',
        french_customEmailContent: (this.state.french_customEmailContent) ? this.state.french_customEmailContent : '',
        scheduleOn: moment(data.scheduleDateTime).format('YYYY-MM-DD HH:mm:ss'),
        cities: data.cityID,
        subscriberType: (data.startDateValue == 'all') ? 'all' : 'NotAll',
        subscriberStartDate: moment(data.startDateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
        subscriberEndDate: moment(data.startDateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
        filterPurchase: (data.purchases == 'category' || data.purchases == 'merchant' || data.purchases == 'not_purchase') ? 'NotAll' : data.purchases,
        catID: data.catID,
        merchantID: data.merchantID,
        dealID: this.state.dealID,
        listData: this.state.listData,
        importedFiles: data.subscriberList,
        second_street: this.state.enable_secondstreet,
        post_up: this.state.enable_postup,
        lang: data.lang,
        campaignCityID: this.state.campaignCityID,
      }
      
      this.props.createEmailManager(saveData);
      isLoading = false;
    }else{
      const updateData = {
        id: campaignID,
        emailType: 'multiOffer',
        campaignName: this.state.campaignName,
        subject: this.state.subject,
        customEmailContent: this.state.customEmailContent,
        french_subject: (this.state.french_subject) ? this.state.french_subject : '',
        french_customEmailContent: (this.state.french_customEmailContent) ? this.state.french_customEmailContent : '',
        scheduleOn: moment(data.scheduleDateTime).format('YYYY-MM-DD HH:mm:ss'),
        cities: data.cityID,
        subscriberType: (data.startDateValue == 'all') ? 'all' : 'NotAll',
        subscriberStartDate: moment(data.startDateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
        subscriberEndDate: moment(data.startDateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
        filterPurchase: (data.purchases == 'category' || data.purchases == 'merchant' || data.purchases == 'not_purchase') ? 'NotAll' : data.purchases,
        catID: data.catID,
        merchantID: data.merchantID,
        dealID: this.state.dealID,
        listData: this.state.listData,
        importedFiles: data.subscriberList,
        second_street: this.state.enable_secondstreet,
        post_up: this.state.enable_postup,
        lang: data.lang,
        campaignCityID: this.state.campaignCityID,
      }
      
      this.props.editEmailManager(updateData);
      isLoading = false;
    }    
  }

  render() {
    const { onSubmit } = this.props
    const { page } = this.state
    return (
      <div className="col-lg-12 add-sub-admin">
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            {this.state.show && this.state.alertMessage !=='' &&        
              <div className="col-lg-12">
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </div>
            }
          </div>
        </div>
        {(campaignID != '') ?
        <div>
        {(page === 1 && this.state.dealID != '') &&
          <ListData
            onListSubmit={this.nextPage} 
            onListSubmitData={this.setData}
            data={this.state}
          />
        }
        </div>
        :
        <div>
        {page === 1  && (
          <ListData
            onListSubmit={this.nextPage} 
            onListSubmitData={this.setData}
            data={this.state}
          />
        )}
        </div>
        }

        {(campaignID != '') ?
        <div>
          {(page === 2 && this.state.campaignName) && 
            <WizardFormFirstPage
              previousPage={this.previousPage}
              onPrevData={this.setData} 
              onSubmit={this.nextPage} 
              onSubmitData={this.setData}
              dataValue={this.state}
              citiesList={this.state.citiesList}
            />
          }
        </div>
        :
        <div>
          {(page === 2) && 
            <WizardFormFirstPage
              previousPage={this.previousPage} 
              onPrevData={this.setData}
              onSubmit={this.nextPage} 
              onSubmitData={this.setData}
              dataValue={this.state}
              citiesList={this.state.citiesList}
            />
          }
        </div>
        }
        
        {page === 3 && (
          <WizardFormSecondPage
            previousPage={this.previousPage}
            onSave={this.saveData}
            onPrevData={this.setData}
            data={this.state}
          />
        )}
      </div>
    )
  }
}

MultiOffer.propTypes = {
  // onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = (state,ownProps) => {
    return {
      activecities: state.countryCityReducers.activecities,
      error: state.emailManagerReducer.error,
      emailStatus:  state.emailManagerReducer.emailStatus,
      emailData: state.emailManagerReducer.emailData,
      template: state.emailManagerReducer.template,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      emailUpdateStatus: state.emailManagerReducer.emailUpdateStatus,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {createEmailManager, getEmailManagerDetail, editEmailManager, emailTemplate, renderAlert, clearAlert, getCities})
)(MultiOffer);


// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/multi/MultiOffer.js